import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BackEndURLSettings } from '~/services/BackEndURL/backEndUrlSettings';
import { EnvironmentLoaderService } from '~/services/BackEndURL/environment-loader.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const accessToken = localStorage.getItem('accessToken');
    const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? "";

    const urlParams = new URLSearchParams(window.location.search);
    const anonymousCustomerID = urlParams.get('CustomerID') || urlParams.get('customerId') || urlParams.get('Customerid') || urlParams.get('customerid');
    const anonymousUsername = urlParams.get('Username') || urlParams.get('username');

    let localKeys: BackEndURLSettings = EnvironmentLoaderService.envConfig;
    const isAnonymous = location.pathname.toLowerCase().includes('renderreport');
    const isApiUrl = request.url.startsWith(localKeys.enterpriseApiLocal);

    if (accessToken && isApiUrl && !isAnonymous) {
      try {
        const parsed = JSON.parse(accessToken);
        const token = parsed?.token || (typeof parsed === 'string' ? parsed : null);
        if (token) {
          request = request.clone({
            setHeaders: { Authorization: `Bearer ${token}`, loggedInAccountSites: `${loggedInAccountSites}` },
          });
        }
      } catch { }
    } else if (isApiUrl && isAnonymous && anonymousCustomerID) {
      const headers: any = { CustomerID: anonymousCustomerID };
      if (anonymousUsername) {
        headers['Username'] = anonymousUsername;
      }
      request = request.clone({
        setHeaders: headers,
      });
    }

    if (request.method !== 'JSONP') {
      request = request.clone({
        setHeaders: { Source: '1' },
      });
    }

    return next.handle(request);
  }
}
